export default {
  title: 'Kundeservice',
  my_account: 'Min konto',
  admin: 'Admin',
  sign_in: 'Logg inn',
  sign_up: 'Registrer',
  sign_out: 'Logg ut',
  home: 'Hjem',
  orders: 'Bestillinger',
  contents: 'Innhold',
  users: 'Bruker',
  roles: 'Rolle',
  claims: 'Krav',
  unauthorized: 'Uautorisert',
  unauthorized_detail: 'Kontakt administratoren din.'
}
